<template>
    <v-container class="d-flex flex-column pa-0 ml-3">

          <v-btn :to="{name: 'kasa.dokumenty' }" x-large :color="$route.name === 'kasa.dokumenty' ? selectedColor : defaultColor"  width="250" active-class="aa" exact>
            Dokument kasowy
          </v-btn>
          <v-btn :to="{name: 'kasa.raporty' }" x-large :color="$route.name === 'kasa.raporty' ? selectedColor : defaultColor"  width="250" active-class="aa" exact>
            Raport kasowy
          </v-btn>
          <v-btn :to="{name: 'kasa.wyciagi' }" x-large :color="$route.name === 'kasa.wyciagi' ? selectedColor : defaultColor"  width="250" active-class="aa" exact>
            Wyciąg bankowy
          </v-btn>
          <v-btn :to="{name: 'kasa.windykacje' }" x-large :color="$route.name === 'kasa.windykacje' ? selectedColor : defaultColor"  width="250" active-class="aa" exact>
            Raport windykacyjny
          </v-btn>
    
    </v-container>
</template>

<script>
export default {
    data(){
        return{
            defaultColor:'secondary', 
            selectedColor:'primary'
        }
    },
    mounted(){
      //pobierabie liczników
      //this.$store.dispatch( 'loadMenuDictionariesCount' );
      //this.$store.dispatch( 'loadLookups' );
    },
    computed:{
      user(){
        return this.$store.getters.getUser;
      },
    },
}
</script>

<style scoped>
.v-btn{
  margin-bottom: 1em;
}
.v-chip{
  margin-left: 1em;
}
.v-chip:hover{
    cursor: pointer;
}

.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
    opacity: 0;
}

</style>